var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleOnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 30Q7.5 30 4.583 27.083 1.667 24.167 1.667 20t2.916-7.083Q7.5 10 11.667 10h16.666q4.167 0 7.084 2.917 2.916 2.916 2.916 7.083t-2.916 7.083Q32.5 30 28.333 30Zm16.708-5.542q1.833 0 3.146-1.291 1.312-1.292 1.312-3.167 0-1.875-1.312-3.167-1.313-1.291-3.146-1.291-1.875 0-3.187 1.291-1.313 1.292-1.313 3.167 0 1.875 1.313 3.167 1.312 1.291 3.187 1.291Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOnIcon);
export default __webpack_public_path__ + "static/media/toggle-on-icon.72e625e2c4cfd7cf1d6bcef6e7792147.svg";
export { ForwardRef as ReactComponent };